import { Typography, type TypographyProps } from '@mui/material';

type Props = Omit<TypographyProps, 'variant'>;

const Text = ({ variant, children, ...props }: TypographyProps) => (
  <Typography variant={variant} {...props}>
    {children}
  </Typography>
);

Text.Title = (props: Props) => <Text variant='h4' color='primary' {...props} />;
Text.H5 = (props: Props) => <Text variant='h5' color='primary' {...props} />;
Text.Body = (props: Props) => <Text variant='body2' {...props} />;
Text.Caption = (props: Props) => <Text variant='caption' {...props} />;
Text.Subtitle = (props: Props) => <Text variant='subtitle1' {...props} />;

export default Text;
